import React, { useState, useRef } from 'react'
import { Icon, Input, Spin, Modal } from "antd"
import { getOrderForAttachTag, markOrderAttachTag } from '../../../services/api/3dApi'
import { NavLink } from 'react-router-dom'
import AttachTagDetail from './AttachTagDetail'
import AttachTagSpecifications from './AttachTagSpecifications'
import { useEffect } from 'react'

function AttachTagPage() {
    const _input = useRef()
    const textRef = useRef()
    const [loading, setLoadingState] = useState(false)
    const [valueInput, setValueInput] = useState('')
    const [actionMessage, setActionMessage] = useState('')
    const [loadingMessage, setLoadingMessage] = useState('Loading...')
    const [actionMessageType, setActionMessageType] = useState('error')
    const [orders, setOrders] = useState('')
    const [processingOrder, setProcessingOrder] = useState('')

    const setLoading = (loading, msg = 'Loading...') => {
        setLoadingState(loading)
        loading && msg && setLoadingMessage(msg)
    }

    const setMessage = (msg, type = 'error') => {
        setActionMessage(msg)
        setActionMessageType(type)
    }

    const getOrderAttachTag = async (barcodeStr) => {
        setLoading(true, <>Đang lấy thông tin đơn #{barcodeStr}...</>)
        setMessage('')
        const response = await getOrderForAttachTag({ barcodeStr }).catch(e => {
            return {
                error: e.message
            }
        })
        
        const { data, success, error: message } = response
        const { processingOrder, orders} = { ...(data || {}) }

        if (!processingOrder || !success) {
            setMessage(message || `Không tìm thấy mã đơn #${barcodeStr}`)
            _resetScanInput(false)
            return Modal.error({
                title: 'Lỗi',
                content: message || `Không tìm thấy mã đơn #${barcodeStr}`,
                //onOk: _resetScanInput(),
                okText: 'Đóng',
            })
        }

        setProcessingOrder(processingOrder)
        setOrders(orders)
    }

    const _onSubmit = async (e) => {
        e && e.preventDefault()

        if (!valueInput || !`${valueInput}`.length) {
            return setMessage('Nhập vào mã đơn.')
        }

        reset(false)

        const checkValue = /^#?\d+_\d+$/.test(valueInput)

        if (!checkValue || !valueInput.trim()) {
            const msg = <>Sai định dạng mã đơn, nhập
                đúng <strong>123456_1</strong> hoặc <strong>#123456_1</strong></>
            setMessage(msg)
            setLoading(false)

            return false
        }

        try {
            await getOrderAttachTag(valueInput.replace(/^#/, ''))
        } catch (error) {
            setMessage(error)
        } finally {
            setLoading(false)
        }
    }

    const _handleChangeScan = e => {
        setValueInput(e.target.value)
        setMessage('')
    }

    const _resetScanInput = (focus = true) => {
        setValueInput('')
        focus && focusInput()
    }

    const focusInput = () => {
        setTimeout(() => {
            _input.current && _input.current.focus()
        }, 300)
    }

    const handleMarkTagged = async () => {
        setLoading(true, <>Đang gửi yêu cầu đánh dấu đơn #{barcodeStr} đã gắn tag mác...</>)

        try {
            const { success, error, data } = await markOrderAttachTag({ barcodeStr })

            if (!success) {
                throw new Error(error)
            }

            let {
                message
            } = { ...data }

            setMessage(message || <>Đơn <strong>#{barcodeStr}</strong> đã được đánh dấu gắn tag mác thành công.</>, '')
            reset()
        } catch (error) {
            setMessage(error.message)
        } finally {
            setLoading(false)
            focusInput()
        }
    }

    const reset = (resetInput = true) => {
        resetInput && _resetScanInput()
        setOrders(false)
        setProcessingOrder(false)
    }

    const _handleInputKeyDown = (e) => {
        if (e.keyCode === 13) {

        } else if (e.keyCode === 27) {

        }
    }

    const onCancel = () => {
        focusInput()
    }

    const barcodeStr = processingOrder && [processingOrder.barcode_number, processingOrder.item_number].join('_')

    useEffect(() => {
        const handlerFocus = () => {
            focusInput()
        }

        window.addEventListener('focus', handlerFocus)

        return () => {
            window.removeEventListener('focus', handlerFocus)
        }
    }, [])

    return (
        <div className="MarkPackagedPage py-5">
            <div className="col-12 mx-auto px-5">
                <div className="row align-items-baseline justify-content-between position-relative">
                    <div className='col-8 d-flex justify-content-between align-items-center' style={{ marginBottom: '20px' }}>
                        <h1 className="PageTitle mb-0 d-flex align-items-center flex-wrap">
                            <span className='mr-4' >Đánh dấu gắn tag mác</span>
                        </h1>
                    </div>
                    <div className="border rounded cursor-pointer font-weight-bold py-2 px-4 bg-white h6 position-absolute" style={{ zIndex: 2, right: 0, top: -40 }}>
                        <NavLink exact to="/attach-tag-item" className="nav-link p-0">
                            Danh sách gắn tag mác
                        </NavLink>
                    </div>
                </div>
                <div className="site-layout-background pb-4">
                    <div className="UpdateOrderPackaged">
                        <div className="UpdateOrderPackagedPage">
                            <div className="position-relative">
                                <Spin spinning={loading} tip={loadingMessage}>
                                    <form onSubmit={_onSubmit} className="mb-4 row">
                                        <div className="col-md-8">
                                            <div className="Input">
                                                <Input
                                                    value={valueInput.toUpperCase()}
                                                    style={{ fontSize: 36, height: "auto" }}
                                                    ref={_input}
                                                    autoFocus={true}
                                                    placeholder="Nhập item cần đánh dấu"
                                                    onChange={_handleChangeScan}
                                                    onKeyDown={_handleInputKeyDown}
                                                />

                                                {
                                                    valueInput && !loading &&
                                                    <Icon
                                                        type="close-circle"
                                                        className="position-absolute cursor-pointer text-dark IconInput"
                                                        onClick={_resetScanInput}
                                                    />
                                                }

                                                {
                                                    loading &&
                                                    <Icon type="sync" spin className="position-absolute IconInput" />
                                                }

                                            </div>

                                            {
                                                actionMessage && <div className={
                                                    actionMessageType === 'error'
                                                        ? 'ErrorMsg alert alert-danger'
                                                        : 'SuccessMsg alert alert-success'
                                                }>{actionMessage}</div>
                                            }

                                            {
                                                !!processingOrder &&
                                                <AttachTagDetail
                                                    processingOrder={processingOrder}
                                                    loadging={loading}
                                                    reset={reset}
                                                    onMarkTagged={handleMarkTagged}
                                                    onCancel={onCancel}
                                                />
                                            }
                                        </div>
                                        <div className="col-md-4 position-relative">
                                            {
                                                !!processingOrder &&
                                                <AttachTagSpecifications
                                                    processingOrder={processingOrder}
                                                />
                                            }
                                        </div>
                                    </form>
                                </Spin>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AttachTagPage